import React from "react";
import { t } from "ttag";

import { LineStatus } from "../../../constants";
import { TrackShipmentDetailsLines } from "../TrackShipmentDetailsLines";
import { TrackShipmentDetailsSimpleTimeline } from "../TrackShipmentDetailsSimpleTimeline";
import {
    OrderDataSource,
    UnifiedDeliveryEvent,
    UnifiedOrderLookupOrderShipment,
} from "../types";

import styles from "./index.module.scss";
import lineStyles from "./lines.module.scss";

export const ShipmentSummary = (props: {
    shipment: UnifiedOrderLookupOrderShipment;
    orderSource: OrderDataSource;
    closestStep: LineStatus;
    unifiedEvents: UnifiedDeliveryEvent[];
    trackShipmentUrl: string;
    warLink: string;
}): React.JSX.Element => {
    return (
        <div className={styles.detailsContainer}>
            <div>
                <TrackShipmentDetailsLines
                    styles={lineStyles}
                    source={props.orderSource}
                    closestStep={props.closestStep}
                    lines={props.shipment.lines}
                    warLink={props.warLink}
                />
            </div>
            <div>
                <TrackShipmentDetailsSimpleTimeline
                    unifiedEvents={props.unifiedEvents}
                />
                {props.shipment.events.length > 0 ? (
                    <a href={props.trackShipmentUrl} className="button">
                        {t`Track Shipment`}
                    </a>
                ) : (
                    <p className={styles.caption}>
                        Tracking information will be provided once your order
                        ships
                    </p>
                )}
            </div>
        </div>
    );
};
